// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reishauer-home {
  --background: var(--bg-primary);
  position: relative;
}
.reishauer-home .loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(var(--bg-primary-rgb), 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}
.reishauer-home .loading-overlay .loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
}
.reishauer-home .loading-overlay .loading-content .loading-text {
  font-size: var(--font-size-body);
  color: var(--text-primary-dark);
  margin: 0;
  font-weight: var(--font-weight-medium);
}

ion-header {
  display: none;
}

ion-content {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.reishauer.scss"],"names":[],"mappings":"AAGA;EACE,+BAAA;EACA,kBAAA;AAFF;AAKE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kCAAA;UAAA,0BAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AAHN;AAKM;EACE,gCAAA;EACA,+BAAA;EACA,SAAA;EACA,sCAAA;AAHR;;AAUA;EACE,aAAA;AAPF;;AAWA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AARF","sourcesContent":["// Reishauer Home Page Styles\n// Integrates with the welcome screen component\n\n.reishauer-home {\n  --background: var(--bg-primary);\n  position: relative;\n\n  // Loading overlay\n  .loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(var(--bg-primary-rgb), 0.9);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n    backdrop-filter: blur(4px);\n\n    .loading-content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: var(--spacing-md);\n      \n      .loading-text {\n        font-size: var(--font-size-body);\n        color: var(--text-primary-dark);\n        margin: 0;\n        font-weight: var(--font-weight-medium);\n      }\n    }\n  }\n}\n\n// Hide default Ionic header\nion-header {\n  display: none;\n}\n\n// Override any body padding\nion-content {\n  --padding-top: 0;\n  --padding-bottom: 0;\n  --padding-start: 0;\n  --padding-end: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
